<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li *ngIf="view"><a [routerLink]="['/contacts']">{{view.getEntityBaseName(true)}}</a></li>
</ul>
<app-view #view [code]="'contacts.list'" [model]="contactsFilters" (onEvent)="onEvent($event)"></app-view>
